










import { Component, Prop, Vue, Mixins } from 'vue-property-decorator'
import PageLayout from '@/components/page/PageLayout.vue'
import RuleForm from './RuleForm.vue'
import addRuleMixin from './addRuleMixin'

@Component({
	name: 'addWPRule',
	components: {
		PageLayout,
		RuleForm,
	},
})
export default class RulesList extends Mixins(addRuleMixin) {
	public created() {
		this.companyId = this.$ls.get('addRuleCompanyId')
	}
}
